/* eslint-disable */
import { asyncLoader } from './AsyncLoader';

class ScrollListener {
	container;

	setContainer(container) {
		this.container = container;
	}

	async onEndOfPostList() {
		await asyncLoader.loadMorePosts();
	}

	addListener() {
		if (asyncLoader.status === 'DONE') return false;
		this._listener = this._listenToScroll.bind(this);
		window.addEventListener('scroll', this._listener);
	}

	removeListener() {
		window.removeEventListener('scroll', this._listener);
		asyncLoader.setStatus('DONE');
	}

	async _listenToScroll() {
		if (asyncLoader.status === 'IN_PROGRESS') return false;
		asyncLoader.setStatus('IN_PROGRESS');
		const distanceBetweenStartPageAndContainer = this.container.getBoundingClientRect().top;
		const containerHeight = this.container.clientHeight;
		const pointOfScreenStartLoading = window.innerHeight;

		if (distanceBetweenStartPageAndContainer + containerHeight < pointOfScreenStartLoading) {
			await this.onEndOfPostList();
		}
		asyncLoader.setStatus('DONE');
	}
}

const scrollListener = new ScrollListener();
export { ScrollListener, scrollListener };
